import type { Dispatch, PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import delay from 'lodash-es/delay';

type NotificationsState = {
  notificationOptions: {
    messages: string[];
    type?: string;
  };
  notificationShown: boolean;
};

const getInitialState = (): NotificationsState => ({
  notificationShown: false,
  notificationOptions: {
    messages: [],
  },
});

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: getInitialState(),
  reducers: {
    showedNotification: (
      state,
      action: PayloadAction<{ messages: string[]; type: string }>
    ) => {
      state.notificationShown = true;
      state.notificationOptions = action.payload;
    },
    hidNotification: () => {
      return getInitialState();
    },
  },
  selectors: {
    selectNotifications: (state) => state,
  },
});

export const {
  reducer: notificationsReducer,
  actions: { showedNotification, hidNotification },
  selectors: { selectNotifications },
} = notificationsSlice;

const hideWithDelay = (dispatch: Dispatch, appearDelay = 6000) => {
  delay(() => dispatch(hidNotification()), appearDelay);
};

export const showSuccessNotification =
  (message: string, appearDelay?: number) => (dispatch: Dispatch) => {
    if (!message) return;
    dispatch(
      showedNotification({
        messages: [message],
        type: 'success',
      })
    );

    hideWithDelay(dispatch, appearDelay);
  };

export const showErrorNotification =
  (message: string, appearDelay?: number) => (dispatch: Dispatch) => {
    if (!message) return;
    dispatch(
      showedNotification({
        messages: [message],
        type: 'error',
      })
    );

    hideWithDelay(dispatch, appearDelay);
  };
